<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-4"><a id="_idTextAnchor004"></a>Angel Prayer 2</h2>
<p class="Verse-new">Stay by me, angel,</p>
<p class="Verse-main">uphold me,</p>
<p class="Verse-main">that my feet don’t slip.</p>
<p class="Verse-new">Beloved child </p>
<p class="Verse-main">of God’s bloodied heart,</p>
<p class="Verse-main">anoint my wounds </p>
<p class="Verse-main">with unction </p>
<p class="Verse-main">of your healing balm. </p>
<p class="Verse-new">Yours the love</p>
<p class="Verse-main">that welcomes grief,</p>
<p class="Verse-main">turning tears</p>
<p class="Verse-main">to silent alleluias</p>
<p class="Verse-main">of the quickened soul.</p>
<p class="Verse-new">Touch me,</p>
<p class="Verse-main">that I may sing them</p>
<p class="Verse-main">heavenly and resounding </p>
<p class="Verse-main">as the angel-voices </p>
<p class="Verse-main">that I hear.</p>
<p class="Verse-new">Change me</p>
<p class="Verse-last">from the wounder</p>
<p class="Verse-last">(or the wounded)</p>
<p class="Verse-last">to one who</p>
<p class="Verse-last">offers salve</p>
<p class="Verse-last">like yours, of love,</p>
<p class="Verse-last">for every broken</p>
<p class="Verse-last">thou.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-6.vue?b1cb94f4